var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"questionRow"},[_c('question-text',{attrs:{"question":_vm.question,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }